import { Component, Input } from '@angular/core';
import {
    ModifiableCodeEnum,
    NewModal as ModalService,
    ProductPremiumDeterminingFactorResponseInterface,
    PurchasedProductInterface,
} from 'outshared-lib';
import {
    InsuranceCancelAddedPremiumDeterminingFactorModal,
} from '../insurance-cancel-added-premium-determining-factor';
import { CommonModule } from '@angular/common';
import { DateFormatPipeModule } from '@app/shared/pipes/date-format/date-format.module';
import { WucButtonModule, WucDisplayFieldModule, WucLinkModule, WucRackModule } from '@inshared/website-ui-components';

@Component({
    selector: 'ins-insurance-premium-determining-factor-future',
    standalone: true,
    imports: [
        CommonModule,
        DateFormatPipeModule,
        WucButtonModule,
        WucDisplayFieldModule,
        WucRackModule,
        WucLinkModule,
    ],
    templateUrl: './insurance-premium-determining-factor-future.component.html',
})
export class InsurancePremiumDeterminingFactorFutureComponent {
    @Input() public premiumDeterminingFactor!: ProductPremiumDeterminingFactorResponseInterface;
    @Input() public purchasedProduct!: PurchasedProductInterface;

    public modifiableCodeEnum = ModifiableCodeEnum;

    constructor(
        private modalService: ModalService,
    ) {
    }

    public async onCancelAddedPremiumDeterminingFactor(): Promise<void> {
        const { InsuranceCancelAddedPremiumDeterminingFactorModal } = await import('../insurance-cancel-added-premium-determining-factor');
        const modalRef = this.modalService
            .open<InsuranceCancelAddedPremiumDeterminingFactorModal>(InsuranceCancelAddedPremiumDeterminingFactorModal);

        modalRef.componentInstance.purchasedProduct = this.purchasedProduct;
        modalRef.componentInstance.premiumDeterminingFactor = this.premiumDeterminingFactor;
    }
}
